import React from 'react'
import PropTypes from 'prop-types'
import { Alert } from 'antd'
import { themeColorLighter1, title } from '@edulastic/colors'
import styled from 'styled-components'

const HiddenFolderTestsBanner = ({ hiddenCount }) => {
  if (!hiddenCount || hiddenCount <= 0) {
    return null
  }

  return (
    <BannerWrapper>
      <Alert
        type="info"
        showIcon
        message={
          <BannerMessage>
            {hiddenCount} Test(s) in this folder are hidden as they are not
            shared with you. Ask the Folder owner / Test authors to share the
            tests with you.
          </BannerMessage>
        }
        style={{
          background: themeColorLighter1,
          border: 'none',
          borderRadius: 4,
        }}
      />
    </BannerWrapper>
  )
}

HiddenFolderTestsBanner.propTypes = {
  hiddenCount: PropTypes.number,
}

HiddenFolderTestsBanner.defaultProps = {
  hiddenCount: 0,
}

export default HiddenFolderTestsBanner

const BannerWrapper = styled.div`
  padding: 8px 32px 0;
`

const BannerMessage = styled.span`
  font-size: 13px;
  color: ${title};
`
